import React from 'react';
import { Container } from '../Components/ui/container';
import { Stack, Inline, Grid } from '../Components/ui/layout';
import { Heading, Text } from '../Components/ui/typography';
import { Input } from '../Components/ui/input';
import { Button } from '../Components/ui/button';
import { Separator } from '../Components/ui/separator';

const Footer = () => {
  const footerLinks = [
    {
      title: 'Explores',
      links: ['Communities', 'Recruiters', 'Jobs', 'Events', 'Forum']
    },
    {
      title: 'Hire learning',
      links: ['Articles', 'Guides', 'Templates', 'Reports', 'Courses']
    },
    {
      title: 'Resources',
      links: ['Blog', 'Podcast', 'Content Library']
    },
    {
      title: 'Product',
      links: ['Attract', 'Qualify', 'Hire', 'Pricing', 'Customers', 'Partners']
    },
    {
      title: 'Support',
      links: ['Help center', 'Developer API', 'Status']
    },
    {
      title: 'For job seekers',
      links: ['Communities', 'Recruiters', 'Jobs', 'Events', 'Forum']
    },
    {
      title: 'Integration',
      links: ['Articles', 'Guides', 'Templates', 'Reports', 'Courses']
    },
    {
      title: 'Solutions',
      links: ['Human Resources', 'Sales & marketing', 'Financial', 'Investor', 'Revenue']
    },
    {
      title: 'Company',
      links: ['About', 'User', 'Teams', 'Contact']
    },
    {
      title: 'Policies',
      links: ['Community', 'Terms of use', 'Privacy Policy', 'Legal', 'Cookies']
    }
  ];

  return (
    <footer className="bg-background border-t border-border">
      <Container>
        <Stack spacing="xl" className="py-xl">
          <Grid cols={5} gap="lg" className="grid-cols-2 md:grid-cols-5">
            {footerLinks.map((section, index) => (
              <Stack key={index} spacing="sm">
                <Heading level="h4" className="text-primary text-lg">
                  {section.title}
                </Heading>
                <ul className="space-y-2">
                  {section.links.map((link, linkIndex) => (
                    <li key={linkIndex}>
                      <a 
                        href="#" 
                        className="text-sm text-foreground hover:text-primary transition-colors"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </Stack>
            ))}
          </Grid>
          
          <Separator />
          
          <Inline justify="between" align="start" className="flex-col md:flex-row gap-xl">
            <Stack spacing="sm" className="max-w-xs">
              <Heading level="h2" className="text-primary text-2xl">
                Logo
              </Heading>
              <Text size="base" variant="muted">
                Lorem ipsum dolor sit amet consectetur. Tortor lacus lectus in faucibus
              </Text>
            </Stack>
            
            <Stack spacing="sm" className="max-w-md">
              <Heading level="h3" className="text-primary text-xl">
                Newsletter
              </Heading>
              <Text size="base" variant="muted">
                Subscribe to our newsletter to get latest Jobs
              </Text>
              <form className="flex flex-col md:flex-row gap-2">
                <div className="relative flex-1">
                  <img 
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/3609ac870fdff9c151473865168dee8da88364119301162455d83106a2660d72?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f" 
                    alt="" 
                    className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 opacity-50" 
                  />
                  <Input 
                    type="email" 
                    placeholder="What's your work email?" 
                    className="pl-10"
                    aria-label="Enter your work email"
                  />
                </div>
                <Button type="submit" variant="default">
                  Subscribe
                </Button>
              </form>
            </Stack>
          </Inline>
          
          <Separator />
          
          <Inline justify="between" align="center" className="flex-col md:flex-row gap-md">
            <Inline spacing="md" className="flex-wrap justify-center">
              <a href="#" className="hover:opacity-80 transition-opacity">
                <img 
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/e75df01f8447fbe54a9ffdd2f2490f3e0384aa381e42861e7a669e3390a942a2?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f" 
                  alt="Social Icon" 
                  className="w-10 h-10 opacity-60 hover:opacity-100 transition-opacity" 
                />
              </a>
              <a href="#" className="hover:opacity-80 transition-opacity">
                <img 
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/0ce78cc1da524b9e04d561e28702e9dc349f6fc465796dcbd46b936983308b0a?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f" 
                  alt="Social Icon" 
                  className="w-10 h-10 opacity-60 hover:opacity-100 transition-opacity" 
                />
              </a>
              <a href="#" className="hover:opacity-80 transition-opacity">
                <img 
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/0d4089a481bc997906b61790cf0381ebd941d808a0a2a8c42e7ede6bf6abe8e3?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f" 
                  alt="Social Icon" 
                  className="w-10 h-10 opacity-60 hover:opacity-100 transition-opacity" 
                />
              </a>
              <a href="#" className="hover:opacity-80 transition-opacity">
                <img 
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/468db4c8c59deb23ad190d54beee3879eeaa1ef57c8135baa464ccb42c22d042?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f" 
                  alt="Social Icon" 
                  className="w-10 h-10 opacity-60 hover:opacity-100 transition-opacity" 
                />
              </a>
            </Inline>
            <Text size="sm" variant="muted">
              @Company name 2024. all Rights Reserved
            </Text>
          </Inline>
        </Stack>
      </Container>
    </footer>
  );
};

export default Footer;